module.exports = __webpack_public_path__ + "img/promotion-image.988bf8d.png";